import React, { FC } from 'react';

import { Icon, Tooltip } from '@silverfort/sf-components';

interface Props {
    text: string;
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
}

const PopupTableColumn: FC<Props> = ({ text, icon }) => {
    return (
        <div className="h-full w-full flex flex-1 items-center gap-[8px]">
            {icon && <Icon icon={icon} size={20} className="flex-none text-sf-gray-400" />}
            <Tooltip title={text} onlyOnOverflow>
                <span className="w-[248px] text-13 text-gray-800 font-sf">{text}</span>
            </Tooltip>
        </div>
    );
};

export default PopupTableColumn;
